import script from "./control.vue?vue&type=script&setup=true&lang=js"
export * from "./control.vue?vue&type=script&setup=true&lang=js"

import "./control.vue?vue&type=style&index=0&id=4706634c&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\code\\Dataleading3.0\\dataleading\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4706634c"]])

export default __exports__